var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H0.5V7.5H7.5V0.5ZM6.5 6.5H1.5V1.5H6.5V6.5Z",
    fill: "#572148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H9V7.5H16V0.5ZM15 6.5H10V1.5H15V6.5Z",
    fill: "#572148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5H24.5V0.5H17.5V7.5ZM18.5 1.5H23.5V6.5H18.5V1.5Z",
    fill: "#572148"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9H0.5V16H7.5V9ZM6.5 15H1.5V10H6.5V15Z",
    fill: "#572148"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H16V9H9V16ZM10 10H15V15H10V10Z",
    fill: "#572148"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16H24.5V9H17.5V16ZM18.5 10H23.5V15H18.5V10Z",
    fill: "#572148"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5H0.5V24.5H7.5V17.5ZM6.5 23.5H1.5V18.5H6.5V23.5Z",
    fill: "#572148"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.5H16V17.5H9V24.5ZM10 18.5H15V23.5H10V18.5Z",
    fill: "#572148"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.5H24.5V17.5H17.5V24.5ZM18.5 18.5H23.5V23.5H18.5V18.5Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/listView.fc325c83b85af5d575be71f1bd73e037.svg";
export { ForwardRef as ReactComponent };